function collapseItem(theme: any, ownerState: any) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } = theme;
  const { active, transparentSidenav, whiteSidenav, darkMode, sidenavColor, miniSidenav } = ownerState || {};

  const { white, transparent, dark, grey, gradients } = palette;
  const { md } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem, rgba, linearGradient } = functions;

  // Improved color logic for better contrast
  const getTextColor = () => {
    if (active) {
      // Active items always use white text for better contrast against colored backgrounds
      return `${white.main} !important`;
    }
    
    if (darkMode) {
      return `${white.main} !important`;
    }
    return `${dark.main} !important`;
  };

  return {
    background: active
      ? linearGradient(gradients[sidenavColor].main, gradients[sidenavColor].state)
      : transparent.main,
    color: getTextColor(),
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    padding: `${pxToRem(6)} ${pxToRem(8)}`,
    margin: `${pxToRem(1)} 0`,
    "@media (max-width:991.98px)": {
      minHeight: pxToRem(48),
      padding: `${pxToRem(10)} ${pxToRem(12)}`,
      margin: `${pxToRem(4)} 0`,
    },
    borderRadius: borderRadius.md,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    overflow: "hidden",
    boxShadow: "none",
    [breakpoints.up("lg")]: {
      ...(miniSidenav
        ? {
            margin: `${pxToRem(2)} ${pxToRem(4)}`,
            padding: `${pxToRem(6)} ${pxToRem(4)}`,
            justifyContent: "center",
            width: "auto",
          }
        : {}),
      transition: transitions.create(["box-shadow", "background-color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    "&:hover, &:focus": {
      backgroundColor: () => {
        if (active) {
          return undefined;
        }
        return darkMode ? rgba(white.main, 0.08) : grey[300];
      },
    },
  };
}

function collapseIconBox(theme: any, ownerState: any) {
  const { palette, transitions, borders, functions, breakpoints } = theme;
  const { transparentSidenav, whiteSidenav, darkMode, active, miniSidenav } = ownerState || {};

  const { white, dark } = palette;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  // Improved icon color logic for better contrast
  const getIconColor = () => {
    if (active) {
      return `${white.main} !important`;
    }
    if (darkMode) {
      return `${white.main} !important`;
    }
    return `${dark.main} !important`;
  };

  return {
    minWidth: pxToRem(24),
    minHeight: pxToRem(24),
    "@media (max-width:991.98px)": {
      minWidth: pxToRem(36),
      minHeight: pxToRem(36),
    },
    flexShrink: 0,
    color: getIconColor(),
    borderRadius: borderRadius.md,
    display: "grid",
    placeItems: "center",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    [breakpoints.up("lg")]: {
          ...(miniSidenav
            ? {
                minWidth: `${pxToRem(28)} !important`,
                minHeight: pxToRem(28),
                marginLeft: 0,
                marginRight: 0,
                "& .MuiIcon-root": {
                  fontSize: "20px !important",
                },
              }
            : {}),
    },

    "& svg, svg g": {
      color: `${getIconColor()} !important`,
    },
  };
}

const collapseIcon = (theme: any, ownerState: any) => {
  const { palette } = theme;
  const { active, transparentSidenav, whiteSidenav, darkMode } = ownerState || {};
  const { white, dark } = palette;

  // Use same improved color logic as other functions
  const getIconColor = () => {
    if (active) {
      return `${white.main} !important`;
    }
    if (darkMode) {
      return `${white.main} !important`;
    }
    return `${dark.main} !important`;
  };

  return {
    color: getIconColor(),
    fontSize: "1.25rem !important",
  };
};

function collapseText(theme: any, ownerState: any) {
  const { typography, transitions, breakpoints, functions, palette } = theme;
  const { miniSidenav, transparentSidenav, whiteSidenav, active, darkMode } = ownerState || {};

  const { size } = typography;
  const { pxToRem } = functions;
  const { white, dark } = palette;

  // Use same improved color logic for text consistency
  const getTextColor = () => {
    if (active) {
      return `${white.main} !important`;
    }
    if (darkMode) {
      return `${white.main} !important`;
    }
    return `${dark.main} !important`;
  };

  return {
    flex: "1 1 auto",
    minWidth: 0,
    marginLeft: pxToRem(8),
    overflow: "hidden",
    "@media (max-width:991.98px)": {
      marginLeft: pxToRem(12),
    },

    [breakpoints.up("lg")]: {
      ...(miniSidenav
        ? {
            display: "none",
            flex: "0 0 0",
            margin: 0,
            overflow: "hidden",
          }
        : {
            display: "block",
            opacity: 1,
            maxWidth: "100%",
            marginLeft: pxToRem(8),
            overflow: "hidden",
          }),
    },

    "& .MuiListItemText-primary, & .MuiTypography-root": {
      fontWeight: 400,
      fontSize: size.sm,
      lineHeight: 1.35,
      color: getTextColor(),
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
